import { Share2, Copy, CheckCheck } from "lucide-react";

const CADENCES = [
  { id: "off", label: "Off" },
  { id: "weekly", label: "Weekly" },
  { id: "monthly", label: "Monthly" },
];

const OG_INTERVALS = [
  { id: "ytd", label: "YTD" },
  { id: "last_7d", label: "7D" },
  { id: "last_30d", label: "30D" },
];

export default function WatchlistControlsBar({
  cadence,
  onChangeCadence,
  isPublic,
  onTogglePublic,
  shareUrl,
  copied,
  onCopy,
  ogInterval,
  onChangeOgInterval,
  watchlistId,
}) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  const ogPreviewUrl =
    isPublic && watchlistId
      ? `${backend}/api/og/wl/${watchlistId}.png?i=${ogInterval}&t=${Math.floor(Date.now() / 60000)}`
      : null;
  return (
    <div className="border-b border-zinc-900 bg-[#0d0d0f]">
      <div className="px-5 py-3 flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="text-label">Cadence</span>
        <div
          className="inline-flex border border-zinc-800"
          role="radiogroup"
          aria-label="Digest cadence"
          data-testid="cadence-group"
        >
          {CADENCES.map((c) => {
            const active = cadence === c.id;
            return (
              <button
                key={c.id}
                data-testid={`cadence-${c.id}`}
                role="radio"
                aria-checked={active}
                onClick={() => onChangeCadence(c.id)}
                className={`px-3 py-1.5 text-[11px] font-mono uppercase tracking-widest transition-colors ${
                  active ? "bg-white text-black" : "text-zinc-400 hover:text-white"
                }`}
              >
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {isPublic && (
          <div className="flex items-center gap-2">
            <span className="text-label" id="og-interval-label">
              OG card
            </span>
            <div
              className="inline-flex border border-zinc-800"
              role="radiogroup"
              aria-labelledby="og-interval-label"
              data-testid="og-interval-group"
            >
              {OG_INTERVALS.map((iv) => {
                const active = ogInterval === iv.id;
                return (
                  <button
                    key={iv.id}
                    data-testid={`og-interval-${iv.id}`}
                    role="radio"
                    aria-checked={active}
                    onClick={() => onChangeOgInterval && onChangeOgInterval(iv.id)}
                    className={`px-2.5 py-1.5 text-[11px] font-mono uppercase tracking-widest transition-colors ${
                      active ? "bg-white text-black" : "text-zinc-400 hover:text-white"
                    }`}
                    title={`Use ${iv.label} TR on the share card`}
                  >
                    {iv.label}
                  </button>
                );
              })}
            </div>
          </div>
        )}
        <button
          data-testid="toggle-public-btn"
          onClick={onTogglePublic}
          role="switch"
          aria-checked={!!isPublic}
          className={`inline-flex items-center gap-1.5 border px-3 py-1.5 text-[11px] font-mono uppercase tracking-widest transition-colors ${
            isPublic
              ? "bg-[#FFD60A] text-black border-[#FFD60A] hover:bg-[#FFD60A]/90"
              : "border-zinc-800 text-zinc-300 hover:border-zinc-500 hover:text-white"
          }`}
        >
          <Share2 size={11} />
          {isPublic ? "Public" : "Make Public"}
        </button>
        {isPublic && (
          <button
            data-testid="copy-share-url-btn"
            onClick={onCopy}
            title={shareUrl}
            className="inline-flex items-center gap-1.5 border border-zinc-800 hover:border-zinc-500 text-zinc-300 hover:text-white px-3 py-1.5 text-[11px] font-mono uppercase tracking-widest transition-colors"
          >
            {copied ? <CheckCheck size={11} className="text-[#00E676]" /> : <Copy size={11} />}
            {copied ? "Copied" : "Copy link"}
          </button>
        )}
      </div>
      </div>
      {ogPreviewUrl && (
        <div className="px-5 pb-4 -mt-1">
          <div className="text-label mb-2">Live OG card preview</div>
          <a
            href={ogPreviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="og-preview-link"
            className="block max-w-md border border-zinc-800 hover:border-zinc-500 transition-colors"
          >
            <img
              data-testid="og-preview-image"
              src={ogPreviewUrl}
              alt="Open Graph preview for this watchlist"
              loading="lazy"
              className="w-full h-auto block"
            />
          </a>
        </div>
      )}
    </div>
  );
}
